var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSparkles(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.7565,
    height: 19.9995,
    viewBox: "0 0 22.7565 19.9995",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4753 4.75198L12.1765 6.31512C11.9828 6.41065 11.7696 6.41065 11.602 6.31512L8.7732 4.74981L9.91778 7.79576C9.98741 7.97379 9.95695 8.18872 9.83727 8.36892L7.82881 11.4561L11.1233 9.87127C11.3169 9.77574 11.5302 9.77574 11.6977 9.87127L14.5287 11.4605L13.3972 8.37109C13.3276 8.19306 13.358 7.97813 13.4777 7.79793L15.4753 4.75198Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.3816 13.657L18.9184 14.825C18.7747 14.8967 18.6137 14.8967 18.4897 14.825L16.3768 13.657L17.2319 15.9323C17.2842 16.0669 17.2602 16.2253 17.171 16.36L15.6718 18.6656L18.1306 17.4824C18.2742 17.4107 18.4353 17.4107 18.5593 17.4824L20.6744 18.6678L19.8301 16.3621C19.7779 16.2275 19.7996 16.069 19.891 15.9344L21.3816 13.657Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.81795 3.70799L0.705058 2.53997L1.56022 4.81521C1.61245 4.94982 1.59069 5.1083 1.4993 5.24291L3.63938e-05 7.54854L2.45891 6.36533C2.60253 6.29368 2.76355 6.29368 2.88759 6.36533L5.00266 7.55071L4.15837 5.24508C4.10614 5.11047 4.1279 4.95199 4.2193 4.81739L5.70986 2.53997L3.24662 3.70799C3.10301 3.77963 2.94198 3.77963 2.81795 3.70799Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8774 1.34395L22.7565 8.01086e-05L21.3029 0.688296C21.218 0.729546 21.1245 0.729546 21.0505 0.688296L19.8036 8.01086e-05L20.3084 1.34178C20.3389 1.41993 20.3259 1.51546 20.2736 1.59362L19.3902 2.95485L20.8416 2.25578C20.9264 2.21453 21.0222 2.21453 21.094 2.25578L22.3408 2.95485L21.8425 1.59362C21.8099 1.51763 21.8229 1.4221 21.8774 1.34395Z",
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.67673 17.0447L8.22315 17.733C8.13829 17.7742 8.04255 17.7742 7.97074 17.733L6.72389 17.0426L7.22872 18.3843C7.25919 18.4624 7.24613 18.5579 7.19391 18.6361L6.30827 19.9995L7.75967 19.3004C7.84453 19.2592 7.94027 19.2592 8.01208 19.3004L9.25893 19.9995L8.76063 18.6383C8.73016 18.5601 8.74322 18.4646 8.79544 18.3864L9.67673 17.0447Z",
    fill: "#13C1BF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSparkles);
export default __webpack_public_path__ + "static/media/ic-sparkles.a8a7ce57544a04ed56daad4c99ff607e.svg";
export { ForwardRef as ReactComponent };